export class TipoOperacaoDTO {
    constructor(prOperacao = null, prNomeOperacao = null) {
        this.Operacao = prOperacao;
        this.NomeOperacao = prNomeOperacao;
    }
}